export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// ./~/@ngx-translate/http-loader/index.js
// module id = 675
// module chunks = 7